var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
function SvgOwners(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "#40AFED",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#owners_svg__clip0_10427_4667)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5 9.198a3 3 0 110-6 3 3 0 010 6zM5 4.53a1.667 1.667 0 100 3.333 1.667 1.667 0 000-3.333zm5 11.333v-.333a5 5 0 10-10 0v.333a.667.667 0 101.333 0v-.333a3.666 3.666 0 117.334 0v.333a.667.667 0 101.333 0zm6-3.333a4.666 4.666 0 00-7.778-3.478.667.667 0 10.89.993 3.333 3.333 0 015.555 2.485.667.667 0 101.333 0zm-4.333-6a3 3 0 110-6 3 3 0 010 6zm0-4.667a1.667 1.667 0 100 3.334 1.667 1.667 0 000-3.334z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "owners_svg__clip0_10427_4667"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(0 .53)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgOwners;